import React from 'react';
import { observer } from 'mobx-react';

import Container from './Container';
import Button from './Button';
import CurrentPage from './CurrentPage';

export default observer(({ paginator }) => (
  <Container>
    <Button onClick={paginator.prevPage} disabled={paginator.page === 1} name="chevron-left" />
    <CurrentPage>{paginator.page}</CurrentPage>
    <Button onClick={paginator.nextPage} disabled={paginator.page >= paginator.last_page} name="chevron-right" />
  </Container>
));
